import { ReportDesignerPageOptions } from "./report-designer-page-options";
import { ReportDesignerWidgetConfig } from "./report-designer-widget-config";

/**
 * Report Designer page
 */
export class ReportDesignerPage {
  /**
   * The ID
   */
  public id?: string = null;

  /**
   * Data loaded flag. Do not persist!
   */
  public dataLoaded?: boolean = false;

  /**
   * Data saved flag. Do not persist!
   */
  public dataSaved?: boolean = false;

  /**
   * Is it a virtual page?
   */
  public isVirtualPage?: boolean = false;

  /**
   * Is it a virtual page master that spawns virtual pages if needed?
   */
  public isVirtualPageMaster?: boolean = false;

  /**
   * The widgets at this page
   */
  public widgets: ReportDesignerWidgetConfig[];

  /**
   * The page options
   */
  public options: ReportDesignerPageOptions;

  /**
   * Apply Report Designer Widget Header mode state to page.
   * @param page Page instance
   * @param mode The Report Designer Widget Header mode state. true turns the Report Designer Widget Header mode on, false turns it off.
   */
  public static applyWidgetHeaderMode(page: ReportDesignerPage, mode: boolean): void {
    const options = page.options;

    //only if mode changed
    if (options.draggable.enabled !== mode) {
      options.draggable.enabled = mode;
      options.resizable.enabled = mode;

      //inform gridster that some options changed
      //api is set after grid initializes, so use api?
      if (options.api?.optionsChanged) {
        options.api?.optionsChanged();
      }
    }
  }
}
